import Country from '@product-web/shared--locale/country'

export const VENDOR_CARDS_COUNTRIES_BLACKLIST: Country[] = [Country.US]

export const BILL_INVOICES_COUNTRIES_WHITELIST: Country[] = [Country.DE]
